"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var utils_1 = require("../utils");
var hooks_1 = require("../hooks");
var MenuItemTooltip_1 = __importDefault(require("./MenuItemTooltip"));
var styles_1 = require("./styles");
var MenuItem = function (_a) {
    var label = _a.label, icon = _a.icon, onClick = _a.onClick, onExpandToggle = _a.onExpandToggle, to = _a.to, isActiveInherited = _a.isActive, badgeNumber = _a.badgeNumber, isExpandable = _a.isExpandable, forwardRef = _a.forwardRef, testId = _a.testId, isMenuOpen = _a.isMenuOpen, disabled = _a.disabled, trailingIcon = _a.trailingIcon, isTargetBlank = _a.isTargetBlank, autoFocusId = _a.autoFocusId;
    var isSidebarOpen = (0, hooks_1.useSidebarState)().isSidebarOpen;
    var _b = (0, react_1.useState)(false), isHovering = _b[0], setIsHovering = _b[1];
    var _c = (0, react_1.useState)(null), tooltipY = _c[0], setTooltipY = _c[1];
    var _d = (0, react_1.useState)(isActiveInherited), isActive = _d[0], setIsActive = _d[1];
    (0, react_1.useEffect)(function () {
        var currentIsActive = !!to && window.location.pathname.startsWith(to);
        setIsActive(currentIsActive);
        return function () { return setIsActive(false); };
    }, [to, window.location.pathname]);
    var handleMouseMove = (0, react_1.useCallback)(function (event) {
        if (!isHovering) {
            setTooltipY(event.currentTarget.getBoundingClientRect().y);
            setIsHovering(true);
        }
    }, [isHovering]);
    var handleMouseLeave = (0, react_1.useCallback)(function () {
        setIsHovering(false);
        setTooltipY(null);
    }, []);
    var handleExpandClick = (0, react_1.useCallback)(function (e) {
        e.stopPropagation();
        e.preventDefault();
        onExpandToggle === null || onExpandToggle === void 0 ? void 0 : onExpandToggle();
    }, [onExpandToggle]);
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        // If the event wasn't prevented and it's Enter or Space
        if (!e.defaultPrevented && (e.key === 'Enter' || e.key === ' ')) {
            // e.preventDefault();
            // If it's expandable, toggle the expansion
            if (isExpandable && onExpandToggle) {
                onExpandToggle();
            }
            // Otherwise, trigger the regular click handler
            else if (onClick) {
                onClick();
            }
            if (autoFocusId && isExpandable && !isMenuOpen) {
                var element = document.querySelector("[data-testid=\"".concat(autoFocusId, "\"]"));
                if (element) {
                    element.focus();
                }
            }
        }
    }, [isExpandable, onClick, onExpandToggle, autoFocusId]);
    var appliedEvents = (0, react_1.useMemo)(function () { return (!isSidebarOpen ? { onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave } : {}); }, [isSidebarOpen, handleMouseMove, handleMouseLeave]);
    var containerClassNames = (0, react_1.useMemo)(function () {
        return (0, classnames_1.default)({
            open: isSidebarOpen,
            active: isActive,
            Disabled: disabled,
            isMenuOpen: isMenuOpen,
        });
    }, [isSidebarOpen, isActive, disabled, isMenuOpen]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [to ? ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ onClick: onClick, className: containerClassNames, as: react_router_dom_1.NavLink, to: to, "$isExpandable": isExpandable, ref: forwardRef }, appliedEvents, { "data-testid": testId, target: isTargetBlank ? '_blank' : undefined, onKeyDown: handleKeyDown, "aria-label": label, "aria-expanded": isExpandable ? isMenuOpen : undefined }, { children: [(0, jsx_runtime_1.jsx)(styles_1.MenuIconWrapper, __assign({ isOpen: isSidebarOpen }, { children: (0, utils_1.renderIcon)(icon) })), (0, jsx_runtime_1.jsx)(styles_1.LabelTypographyBody, __assign({ size: "lg" }, { children: label })), badgeNumber && (0, jsx_runtime_1.jsx)(styles_1.BadgeNumber, { children: badgeNumber }), isExpandable && ((0, jsx_runtime_1.jsx)(styles_1.TrailingMenuIconWrapper, __assign({ "data-testid": "".concat(testId, "-expand-toggle"), onClick: handleExpandClick, className: (0, classnames_1.default)({ isMenuOpen: isMenuOpen && !trailingIcon }) }, { children: (0, utils_1.renderIcon)(trailingIcon !== null && trailingIcon !== void 0 ? trailingIcon : 'agco_chevron-down') })))] }))) : ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ className: containerClassNames }, appliedEvents, { onClick: onClick, ref: forwardRef, "data-testid": testId, onKeyDown: handleKeyDown, role: "button", "aria-label": label, tabIndex: 0, "aria-expanded": isExpandable ? isMenuOpen : undefined }, { children: [(0, jsx_runtime_1.jsx)(styles_1.MenuIconWrapper, __assign({ isOpen: isSidebarOpen }, { children: (0, utils_1.renderIcon)(icon) })), (0, jsx_runtime_1.jsx)(styles_1.LabelTypographyBody, __assign({ size: "lg" }, { children: label })), badgeNumber && (0, jsx_runtime_1.jsx)(styles_1.BadgeNumber, { children: badgeNumber }), isExpandable && ((0, jsx_runtime_1.jsx)(styles_1.TrailingMenuIconWrapper, __assign({ "data-testid": "".concat(testId, "-expand-toggle"), onClick: handleExpandClick, className: (0, classnames_1.default)({ isMenuOpen: isMenuOpen && !trailingIcon }) }, { children: (0, utils_1.renderIcon)(trailingIcon !== null && trailingIcon !== void 0 ? trailingIcon : 'agco_chevron-down') })))] }))), tooltipY && (0, jsx_runtime_1.jsx)(MenuItemTooltip_1.default, { tooltipY: tooltipY, label: label })] }));
};
exports.default = MenuItem;
